import { useEffect } from "react";
import { BrowserRouter as AppBrowserRouter } from "react-router-dom";

import {
  AppStateProvider,
  AppThemeProvider,
  AppAlertsProvider,
  AppRouterProvider,
  // AppAdapterProvider,
  AppTranslateProvider,
} from "./providers";
import { tryRecoverChunkLoadError } from "@/shared/utils/chunkLoadRecovery";

export const App = () => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (tryRecoverChunkLoadError(event.error)) {
        event.preventDefault();
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (tryRecoverChunkLoadError(event.reason)) {
        event.preventDefault();
      }
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, []);

  return (
    // <AppAdapterProvider>
    <AppTranslateProvider>
      <AppStateProvider>
        <AppThemeProvider>
          <AppAlertsProvider>
            <AppBrowserRouter>
              <AppRouterProvider />
            </AppBrowserRouter>
          </AppAlertsProvider>
        </AppThemeProvider>
      </AppStateProvider>
    </AppTranslateProvider>
    // </AppAdapterProvider>
  );
};
